/* global axios */
import ApiClient from './ApiClient';

class LineItemsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  baseLineItemsUrl(pipelineId, dealId) {
    return `${this.baseUrl()}/pipelines/${pipelineId}/deals/${dealId}/line_items`;
  }

  index(pipelineId, dealId) {
    return axios.get(this.baseLineItemsUrl(pipelineId, dealId));
  }

  createItem(pipelineId, dealId, data) {
    return axios.post(this.baseLineItemsUrl(pipelineId, dealId), {
      line_item: data,
    });
  }

  updateItem(pipelineId, dealId, lineItemId, data) {
    return axios.patch(
      `${this.baseLineItemsUrl(pipelineId, dealId)}/${lineItemId}`,
      { line_item: data }
    );
  }

  // Substitui a lista inteira num request so — o modal salva o rascunho de uma vez.
  bulkUpdate(pipelineId, dealId, lineItems) {
    return axios.patch(
      `${this.baseLineItemsUrl(pipelineId, dealId)}/bulk_update`,
      { line_items: lineItems }
    );
  }

  destroyItem(pipelineId, dealId, lineItemId) {
    return axios.delete(
      `${this.baseLineItemsUrl(pipelineId, dealId)}/${lineItemId}`
    );
  }
}

export default new LineItemsAPI();
